import { render } from "./signupThanks.vue?vue&type=template&id=05b7d639"
import script from "./signupThanks.vue?vue&type=script&lang=js"
export * from "./signupThanks.vue?vue&type=script&lang=js"

import "./signupThanks.vue?vue&type=style&index=0&id=05b7d639&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__